import { render, staticRenderFns } from "./NewFileUpload.vue?vue&type=template&id=6783b61e&scoped=true"
import script from "./NewFileUpload.vue?vue&type=script&lang=js"
export * from "./NewFileUpload.vue?vue&type=script&lang=js"
import style0 from "./NewFileUpload.vue?vue&type=style&index=0&id=6783b61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6783b61e",
  null
  
)

export default component.exports